import React from 'react';
import SingleLinkForm from './SingleLinkForm';

interface LinkFormProps {
  isEditMode?: boolean;
  isReadonly?: boolean;
}

const LinkForm: React.FC<LinkFormProps> = ({
  isEditMode = false,
  isReadonly = false,
}) => {
  return <SingleLinkForm isEditMode={isEditMode} isReadonly={isReadonly} />;
};

LinkForm.defaultProps = {
  isEditMode: false,
  isReadonly: false,
};

export default LinkForm;
